import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostCollection_pointsInvoicesParsed_data_cache = z.any()
export type TagsPostCollection_pointsInvoicesParsed_data_cache = z.infer<typeof tagsPostCollection_pointsInvoicesParsed_data_cache>

export const descriptionPostCollection_pointsInvoicesParsed_data_cache = z.any()
export type DescriptionPostCollection_pointsInvoicesParsed_data_cache = z.infer<typeof descriptionPostCollection_pointsInvoicesParsed_data_cache>

export const bodyPostCollection_pointsInvoicesParsed_data_cache = z.object({ "fileNames": z.array(z.string()), "parseMode": z.union([z.literal("single"), z.literal("bulk")]).optional() })
export type BodyPostCollection_pointsInvoicesParsed_data_cache = z.infer<typeof bodyPostCollection_pointsInvoicesParsed_data_cache>

export const responsePostCollection_pointsInvoicesParsed_data_cache = z.object({ "payload": z.any().optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostCollection_pointsInvoicesParsed_data_cache = z.infer<typeof responsePostCollection_pointsInvoicesParsed_data_cache>

interface IPostCollection_pointsInvoicesParsed_data_cache extends BaseMethodType {
  tags: TagsPostCollection_pointsInvoicesParsed_data_cache,
  description: DescriptionPostCollection_pointsInvoicesParsed_data_cache,
  body: BodyPostCollection_pointsInvoicesParsed_data_cache,
  response: ResponsePostCollection_pointsInvoicesParsed_data_cache
}
export const URL = '/collection-points/invoices/parsed-data-cache'
export const validation = {
  post: {
    tags: tagsPostCollection_pointsInvoicesParsed_data_cache,
    description: descriptionPostCollection_pointsInvoicesParsed_data_cache,
    body: bodyPostCollection_pointsInvoicesParsed_data_cache,
    response: responsePostCollection_pointsInvoicesParsed_data_cache
  }
}
export interface Collection_pointsInvoicesParsed_data_cache extends BaseRouteType {
  post: IPostCollection_pointsInvoicesParsed_data_cache
}